import { ErrorResponse } from 'types/interface/error.interface';
import { RequestLogsParams, RequestLogsResponse } from 'types/interface/request-logs.interface';

export const FETCH_REQUEST_LOGS_API = 'FETCH_REQUEST_LOGS_API';
export const FETCH_REQUEST_LOGS_SUCCESS_API = 'FETCH_REQUEST_LOGS_SUCCESS_API';
export const FETCH_REQUEST_LOGS_FAILURE_API = 'FETCH_REQUEST_LOGS_FAILURE_API';

export const RESET_STORAGE_REQUEST_LOGS = 'RESET_STORAGE_REQUEST_LOGS';
export const RESET_REQUEST_LOGS_ERROR = 'RESET_REQUEST_LOGS_ERROR';
export const RESET_REQUEST_LOGS_RESPONSE = 'RESET_REQUEST_LOGS_RESPONSE';

export const fetchRequestLogsApi = (
  payload?: RequestLogsParams | string,
): { type: string; payload: RequestLogsParams | string } => {
  return {
    type: FETCH_REQUEST_LOGS_API,
    payload,
  };
};

export const fetchRequestLogsSuccessApi = (
  payload: RequestLogsResponse,
): { payload: RequestLogsResponse; type: string } => ({
  type: FETCH_REQUEST_LOGS_SUCCESS_API,
  payload,
});

export const fetchRequestLogsFailureApi = (
  payload: ErrorResponse,
): { payload: ErrorResponse; type: string } => ({
  type: FETCH_REQUEST_LOGS_FAILURE_API,
  payload,
});
